import begin from './begin-upload';
import get from './get-uploads';
import abort from './abort-upload';

export default {
  begin,
  get,
  abort,
};
